import React, { useEffect, useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
} from '@mui/material';
import {
  Group,
  Person,
  Assignment,
  AttachMoney,
} from '@mui/icons-material';
import { permissionService, Permissions } from '../services/permissionService';

const DRAWER_WIDTH = 240;

interface UserManagementSidebarProps {
  selectedView: 'roles' | 'users' | 'userroles' | 'subscriptions';
  setSelectedView: (view: 'roles' | 'users' | 'userroles' | 'subscriptions') => void;
}

const menuItems = [
  { 
    text: 'Szerepek', 
    icon: <Group />, 
    key: 'roles',
    permission: Permissions.ViewRoles 
  },
  { 
    text: 'Felhasználók', 
    icon: <Person />, 
    key: 'users',
    permission: Permissions.ViewUsers 
  },
  { 
    text: 'Felhasználói szerepek', 
    icon: <Assignment />, 
    key: 'userroles',
    permission: Permissions.ManageUserRoles 
  },
  { 
    text: 'Előfizetések és költségek', 
    icon: <AttachMoney />, 
    key: 'subscriptions',
    permission: Permissions.ViewBilling 
  },
];

const UserManagementSidebar: React.FC<UserManagementSidebarProps> = ({ 
  selectedView, 
  setSelectedView 
}) => {
  const [visibleMenuItems, setVisibleMenuItems] = useState(menuItems);

  useEffect(() => {
    // Filter menu items based on permissions
    const filterMenuItems = () => {
      const filtered = menuItems.filter(item => 
        permissionService.hasPermission(item.permission)
      );
      setVisibleMenuItems(filtered);
    };

    // Initial filter
    filterMenuItems();

    // Subscribe to permission changes
    const unsubscribe = permissionService.onPermissionsChanged(() => {
      filterMenuItems();
    });

    // Cleanup subscription
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          backgroundColor: '#ff8c42', // Narancssárga szín
          color: 'white',
        },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          {visibleMenuItems.map((item) => (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                selected={selectedView === item.key}
                onClick={() => setSelectedView(item.key as 'roles' | 'users' | 'userroles' | 'subscriptions')}
                sx={{
                  color: 'white',
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  },
                }}
              >
                <ListItemIcon sx={{ color: 'white' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default UserManagementSidebar;
